import React from 'react';
import { InputBaseComponentProps } from '@mui/material/InputBase';
import { StyledInput } from './input.style';

export const Input = React.forwardRef(function Input(props: InputBaseComponentProps, ref) {
    return <StyledInput {...props} ref={ref} />;
});
